{
  "name": "cropmap-app",
  "version": "2.1.9-legacy",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4201",
    "build": "ng build",
    "build:test": "ng build --configuration=test",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "format": "npx prettier --write 'src/**/*.{ts,scss,html}'"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.2",
    "@angular/cdk": "^19.2.3",
    "@angular/common": "^19.2.2",
    "@angular/compiler": "^19.2.2",
    "@angular/core": "^19.2.2",
    "@angular/forms": "^19.2.2",
    "@angular/platform-browser": "^19.2.2",
    "@angular/platform-browser-dynamic": "^19.2.2",
    "@angular/router": "^19.2.2",
    "@angular/service-worker": "^19.2.2",
    "@mapbox/mapbox-gl-draw": "^1.4.3",
    "@mapbox/mapbox-gl-geocoder": "^5.0.1",
    "@microsoft/applicationinsights-web": "^3.2.1",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^6.0.0",
    "@primeng/themes": "^18.0.2",
    "@sentry/angular": "^9.3.0",
    "@sentry/cli": "^2.42.2",
    "@turf/turf": "^6.5.0",
    "bootstrap": "^5.2.0",
    "echarts": "^5.3.3",
    "eva-icons": "^1.1.3",
    "file-saver": "^2.0.5",
    "google-libphonenumber": "^3.2.37",
    "guid-typescript": "^1.0.9",
    "html2canvas": "^1.4.1",
    "mapbox-gl": "^2.10.0",
    "moment": "^2.29.4",
    "ngx-echarts": "^8.0.1",
    "ngx-mask": "^16.4.2",
    "ngx-pagination": "^6.0.3",
    "primeng": "^19.0.9",
    "rollbar": "^2.26.2",
    "rxjs": "^7.8.1",
    "tinycolor2": "^1.4.2",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.3",
    "@angular/cli": "^19.2.3",
    "@angular/compiler-cli": "^19.2.2",
    "@types/file-saver": "^2.0.5",
    "@types/google-libphonenumber": "^7.4.26",
    "@types/jasmine": "~3.10.0",
    "@types/mapbox__mapbox-gl-draw": "^1.4.6",
    "@types/mapbox__mapbox-gl-geocoder": "^4.7.3",
    "@types/mapbox-gl": "^2.7.5",
    "@types/node": "^12.11.1",
    "@types/tinycolor2": "^1.4.3",
    "jasmine-core": "~3.10.0",
    "karma": "^6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.1.0",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "prettier": "^3.1.1",
    "typescript": "~5.8.2"
  }
}
